import events from 'events.js';
import http from 'http.js';
import ko from 'knockout';
import ThreadReply from 'qa/models/thread_reply.js';

import 'ko/bindings/stop_binding.js';
import 'ko/bindings/tooltip.js';

class ReplyManager {
    constructor(userId) {
        this.userId = userId;
        this.loading = ko.observable(false);
        this.replies = ko.observableArray();
    }

    async loadMore() {
        this.loading(true);
        const data = await http.get({
            url: this.nextUrl,
            data: {user: this.userId},
        });

        for (const v of data.results || []) {
            const tr = new ThreadReply();
            tr.setData(v);
            this.replies.push(tr);
        }
        this.nextUrl = data.next;
        this.loading(false);
    }

    async load() {
        await events.ready();
        const userId = document.body.getAttribute('data-user-id');
        this.nextUrl = `/api/accounts/v1/${userId}/thread-replies/`;

        if (document.body.dataset.initReplyCount) {
            this.nextUrl += `?limit=${document.body.dataset.initReplyCount}`;
        }

        await this.loadMore();

        const elem = document.getElementById('see-all-answers');
        if (!elem) {
            return;
        }
        ko.applyBindings(this, elem);

        const answers = document.getElementById('recent-answers');
        if (answers) {
            ko.applyBindings(null, answers);
        }
    }
}

new ReplyManager().load();
